import { useAccessControl, useCurrentUser } from '@billx/api';
import { WEB_STAFF_NAV_DEFS } from '@billx/utils';
import {
  ChefHatIcon,
  HandPlatterIcon,
  HomeIcon,
  ReceiptIndianRupeeIcon,
  TruckIcon,
} from 'lucide-react';
import type { ReactNode } from 'react';

import type { NavItem } from '@/components/common';

const STAFF_ICONS: Record<string, ReactNode> = {
  home: <HomeIcon size={18} />,
  billing: <ReceiptIndianRupeeIcon size={18} />,
  waiter: <HandPlatterIcon size={18} />,
  kitchen: <ChefHatIcon size={18} />,
  delivery: <TruckIcon size={18} />,
};

export const useStaffNavItems = (): NavItem[] => {
  const { canAccessPage } = useAccessControl();
  const { currentUser } = useCurrentUser();

  if (!currentUser) {
    return [];
  }

  const allItems: NavItem[] = WEB_STAFF_NAV_DEFS.map((def) => ({
    id: def.id,
    label: def.label,
    icon: STAFF_ICONS[def.id],
    path: def.webPath,
    pageKey: def.pageKey,
  }));

  return allItems.filter((item) => canAccessPage(item.pageKey));
};
